module.exports = __webpack_public_path__ + "img/stock0.1fb56f19.png";